/**
 * 指挥页 DASHBOARD_STYLES 只注入一次（门禁壳与 Authenticated 共用）
 */
let stylesInjected = false;

export function injectDashboardStyles(cssText) {
  if (stylesInjected || typeof document === 'undefined') return;
  const style = document.createElement('style');
  style.setAttribute('data-zhxt-dashboard-styles', '1');
  style.textContent = cssText;
  document.head.appendChild(style);
  stylesInjected = true;
}
